// extracted by mini-css-extract-plugin
export default {"divider":"courseList_divider__DZmzm","eachCollapse":"courseList_eachCollapse__34LzQ","deleteBtn":"courseList_deleteBtn__T1tOz","deleteBlock":"courseList_deleteBlock__pD9OL"};